import { FC, useEffect, useState } from "react"

import { IReadOptions } from "../../services/models"
import { ProgressIndicator, Spinner } from "../../widgets"
import clsx from "clsx"
import { toAbsoluteUrl } from "../../../helpers"
import { useAuth } from "../../../modules/auth"
import { useLazyReadQuery } from "../../services/data/tableDataApi"
import { useParams } from "react-router-dom"

interface IContactCardProps {
    contactId: string,
    className?: string,
    loadingContactId?: string | null
}

export const ContactCard: FC<IContactCardProps> = ({
    contactId,
    className,
    loadingContactId
}) => {
    const { user } = useAuth()
    const { siteId } = useParams()

    const [readContact, { isLoading }] = useLazyReadQuery()
    const [contact, setContact] = useState<{ fullName: string, rollNumber: string, entityImage?: string }>()

    useEffect(() => {
        if (!siteId) return

        const options: IReadOptions = {
            portalId: siteId,
            userId: user?.userId || '',
            tableId: "contact",
            sysId: contactId,
            fieldList: ["fullname", "slcm_rollnumber", "entityimage"]
        }

        readContact(options)
            .unwrap()
            .then((result) => {
                setContact({
                    fullName: result["fullname"],
                    rollNumber: result["slcm_rollnumber"],
                    entityImage: result["entityimage"]
                })
            })
            .catch((error) => {
                console.log(error)
            })
        // eslint-disable-next-line
    }, [contactId])

    if (isLoading)
        return <Spinner />

    if (!contact)
        return <></>

    return (
        <div
            className={clsx(className, "card")}
            style={{
                width: "240px",
                minWidth: "240px",
                height: "320px",
                minHeight: "320px",
                overflow: "hidden"
            }}
        >
            <div className="card-body d-flex justify-content-center">
                {contact.entityImage ? (
                    <img
                        alt="Logo"
                        className="rounded-circle mh-100px"
                        src={`data:image/png;base64, ${contact.entityImage}`}
                    />
                ) : (
                    <img
                        alt="Logo"
                        className="rounded-circle mh-100px"
                        src={toAbsoluteUrl('/media/avatars/blank.png')}
                    />
                )}
            </div>

            <div className="card-body">
                {loadingContactId === contactId && (
                    <ProgressIndicator show={true} />
                )}
                {/* FIXED SECTION FOR NAME */}
                <div
                    style={{
                        height: "50px",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center"
                    }}
                >
                    <label className="fs-4 fw-bold text-center">
                        {contact.fullName}
                    </label>
                </div>

                {/* FIXED SECTION FOR JGU STUDENT ID */}
                <div
                    style={{
                        height: "60px",
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        textAlign: "center"
                    }}
                >
                    <label className="fw-semibold">JGU Student ID</label>
                    <p className="m-0 fw-bold">{contact.rollNumber}</p>
                </div>
            </div>
        </div>
    )
}